import * as React from 'react';
import { useDevicesStore } from '../../stores';
import { useEffect, useMemo, useState } from 'react';
import ControlledInput from '../../components/ControlledInput';
import ControlledMultiDropdown from '../../components/ControlledMultiDropdown';
import BtnFilled from '../../components/BtnFilled';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';

const ItemForm = ({ group, index, handleSubmit, devices }) => {
  const { watch, formState } = useFormContext();
  const fieldName = `${index}.description`;
  const idsFieldName = `${index}.ids`;

  const [isEditGroup, setEditGroup] = useState({});
  const isEditing = isEditGroup[group];

  const getDevicesInGroup = (group) => {
    return devices.filter((dev) => dev.description === group).map((dev) => dev.id);
  };

  const selectedDeviceIds = getDevicesInGroup(group);

  const options = useMemo(() => {
    return devices.map((item) => ({
      label: item.serial_number,
      value: item.id,
    }));
  }, [devices]);

  const values = watch([fieldName, idsFieldName]);
  const isDirtyGroup = formState.dirtyFields?.[index]?.description || formState.dirtyFields?.[index]?.ids;
  const isValidGroup = values[0] && Array.isArray(values[1]) && values[1].length > 0;

  const onSaveGroup = () => {
    handleSubmit({ description: values[0], ids: values[1] || [] });
  };

  return (
    <div className="border border-gray-300 rounded-xl shadow hover:bg-gray-100 mx-4">
      <div
        onClick={() =>
          setEditGroup((prev) => ({
            ...prev,
            [group]: !prev[group],
          }))
        }
        key={group}
        className="cursor-pointer p-4">
        {group}
      </div>
      {isEditing && (
        <div className="p-4 pt-0">
          <ControlledInput
            defaultValue={group}
            label={'Название группы'}
            rules={{ required: 'Введите название группы' }}
            name={fieldName}
            placeholder={'Введите название группы устройств'}
          />
          <ControlledMultiDropdown
            name={idsFieldName}
            defaultValue={selectedDeviceIds}
            label={'Список устройств'}
            placeholder={'Выберите устройства'}
            rules={{ required: 'Выберите хотя бы одно устройство' }}
            options={options}
          />
          <BtnFilled disabled={!isDirtyGroup || !isValidGroup} className="max-w-[240px] mt-4" title="Сохранить изменения" btnCb={onSaveGroup} type={'button'} />
        </div>
      )}
    </div>
  );
};

const UpdateForm = ({ handleSubmit }) => {
  const methods = useForm({ mode: 'onChange' });

  const { devices, devicesExist } = useDevicesStore();
  const [groups, setGroups] = useState([]);

  const createTypesArray = () => {
    const typesArr = devices.map((dev) => dev.description).filter((desc) => desc && desc.trim() !== '');
    const unique = Array.from(new Set(typesArr));
    setGroups(unique);
  };

  useEffect(() => {
    if (devicesExist) {
      createTypesArray();
    }
  }, []);

  return (
    <FormProvider {...methods}>
      <form className="flex flex-col gap-4 mb-4">
        <p className="truncate text-md sm:text-md md:text-xl xl:text-2xl 2xl:text-2xl px-4">Редактирование группы</p>

        {groups.map((group, index) => {
          return <ItemForm key={index} group={group} index={index} handleSubmit={handleSubmit} devices={devices} />;
        })}
      </form>
    </FormProvider>
  );
};
export default UpdateForm;
